import { Section } from '@/declarations/models/Section';
import { SectionType } from '@/declarations/models/SectionType';
import { BlockType } from '@/declarations/models/BlockType';
import { BannerBlock } from '@/declarations/models/blocks/BannerBlock';
import { ArticleTitleBlock } from '@/declarations/models/blocks/ArticleTitleBlock';

const BANNER_TYPES: Array<string> = [BlockType.FRONTPAGE, BlockType.BANNER];

/** The portal leaves out hidden sections and blocks (core/page/page_rendering.py). */
const visibleBlocks = (sections: Array<Section>) =>
  sections
    .filter((s) => s.visible !== 'hidden' && s.type !== SectionType.ARTICLE_LINKS)
    .flatMap((s) => (s.blocks ?? []).filter((b) => b.visible !== 'hidden').map((block) => ({ section: s, block })));

/**
 * Whether the portal shows the page with an h1 (portal/frontend/headings.py, framework/article.html): the title block
 * in the head section, falling back to the page title, or a banner whose title is set as the page's main heading.
 */
export const pageHasMainHeading = (sections: Array<Section>, pageTitle?: string): boolean =>
  visibleBlocks(sections).some(({ section, block }) => {
    if (block.type === BlockType.ARTICLE_TITLE && section.type === SectionType.ARTICLE_HEAD) {
      const title = block as ArticleTitleBlock;
      return !title.hidetitle && Boolean(title.title?.trim() || pageTitle?.trim());
    }
    if (BANNER_TYPES.includes(block.type)) {
      const banner = block as BannerBlock;
      return banner.titleLevel === 'h1' && !banner.hidetitle && Boolean(banner.title?.trim());
    }
    return false;
  });
